import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import styled from "styled-components";

type ComboBoxOptionProps = {
  $width?: number | string;
};

const ComboBoxOptionBase = styled(DropdownMenu.RadioItem)<ComboBoxOptionProps>`
  align-items: center;
  color: ${({ theme }) => theme.colors.content};
  display: flex;
  font-family: ${({ theme }) => theme.typography.family};
  font-size: ${({ theme }) => theme.typography.sizeSM.toString()};
  height: 48px;
  ${({ $width }) =>
    $width && typeof $width === "number" ? `width: ${$width}px` : `width: ${$width}`};
  justify-content: top;
  margin-top: 0px;
  padding-left: 16px;
  padding-right: 8px;
  user-select: none;
  background-color: ${({ theme }) => theme.colors.backgroundElevated3};
`;

export const ComboBoxOptionDefault = styled(ComboBoxOptionBase)<ComboBoxOptionProps>`
  &:hover {
    background-color: ${({ theme }) => theme.colors.backgroundHover};
  }

  &:focus {
    background-color: ${({ theme }) => theme.colors.backgroundHover};
    border: none;
    outline: none;
  }

  &[data-state="checked"] {
    background-color: ${({ theme }) => theme.colors.backgroundAccentBlue};
    border: none;
    color: ${({ theme }) => theme.colors.contentInverse};
    outline: none;
  }
`;

export const ComboBoxOptionSubtle = styled(ComboBoxOptionBase)<ComboBoxOptionProps>`
  align-items: center;
  color: ${({ theme }) => theme.colors.contentSubtle};
  display: flex;
  font-family: ${({ theme }) => theme.typography.family};
  font-size: ${({ theme }) => theme.typography.sizeRoot.toString()};
  height: 48px;
  ${({ $width }) =>
    $width && typeof $width === "number" ? `width: ${$width}px` : `width: ${$width}`};
  justify-content: top;
  margin-top: 0px;
  padding: 0 8px;
  user-select: none;
  background-color: ${({ theme }) => theme.colors.backgroundElevated3};

  div {
    width: 100%;
    padding: 8px;
    border-radius: 6px;
  }

  &:hover div {
    background-color: ${({ theme }) => theme.colors.backgroundHover};
  }

  &:focus div {
    background-color: ${({ theme }) => theme.colors.backgroundHover};
    border: none;
    outline: none;
  }

  &[data-state="checked"] {
    padding-left: 6px;
  }

  &[data-state="checked"] div {
    background-color: ${({ theme }) => theme.colors.backgroundSelected};
    color: ${({ theme }) => theme.colors.contentSelected};
    font-weight: ${({ theme }) => theme.typography.weightBold};
    border-radius: 6px;
    width: 100%;
    outline: none;
    padding: 8px;
  }
`;

const DropdownMenuContentBase = styled(DropdownMenu.Content)<ComboBoxOptionProps>`
  ${({ $width }) =>
    $width && typeof $width === "number" ? `width: ${$width}px` : `width: ${$width}`};
  border-radius: 8px;
  padding: 8px 0;
  background-color: ${({ theme }) => theme.colors.backgroundElevated2};
  &:focus {
    outline: none;
  }
`;

export const DropdownMenuContentDefault = styled(DropdownMenuContentBase)<ComboBoxOptionProps>`
  box-shadow:
    0px 4px 24px 0px rgba(0, 0, 0, 0.24),
    0px 2px 8px 0px rgba(0, 0, 0, 0.12);
`;

export const DropdownMenuContentSubtle = styled(DropdownMenuContentBase)<ComboBoxOptionProps>`
  box-shadow:
    0px 8px 20px 0px rgba(0, 0, 0, 0.04),
    0px 1px 1px 0px rgba(0, 0, 0, 0.03);
`;
